import {
  ReservierungsDetails,
  ReservierungsMoeglichkeit,
} from '@codefluegel/wowis-rest-typescript-client';
import { useEffect, useState } from 'react';
import { useReservationApi } from '../ApiClient';

function useReservations(customerId?: number) {
  const [reservations, setReservations] = useState<ReservierungsDetails[]>();
  const [reservationPossiblities, setReservationsPossiblities] =
    useState<ReservierungsMoeglichkeit[]>();

  const reservationApi = useReservationApi();

  // fetching all possible reservations
  const getReservationData = async () => {
    const { data } = await reservationApi.getAllReservierungsMoeglichkeiten(
      Number(customerId) || 0,
    );
    setReservationsPossiblities(data);
  };

  // fetching all reservations in the last year and the next year
  const getReservations = async () => {
    const minusDate = new Date();
    minusDate.setFullYear(minusDate.getFullYear() - 1);

    const plusDate = new Date();
    plusDate.setFullYear(plusDate.getFullYear() + 1);

    const { data } = await reservationApi.searchReservierungen(
      minusDate.toISOString().slice(0, 10),
      plusDate.toISOString().slice(0, 10),
      Number(customerId) || 0,
    );
    setReservations(data);
  };
  useEffect(() => {
    if (!reservationPossiblities) getReservationData();
    if (!reservations) getReservations();
  }, [reservations, reservationApi]);

  return {
    reservations,
    reservationPossiblities,
    getReservations,
  };
}

export default useReservations;
